var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.clickable ? "button" : "span",
    {
      tag: "component",
      staticClass: "ruolo-mantra",
      class: [
        "ruolo-mantra" + _vm.mantraId,
        {
          outlined: _vm.outlined,
          small: _vm.small,
          "is-clickable": _vm.clickable,
        },
      ],
      attrs: {
        type: _vm.clickable ? "button" : null,
        disabled: _vm.clickable ? _vm.disabled : null,
        "aria-pressed": _vm.clickable ? !_vm.outlined : null,
        title: _vm.ruolo.descr,
      },
      on: { click: _vm.handleClick },
    },
    [_vm._v(_vm._s(_vm.ruolo.label))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }